export const barcodeQtyImportActions = {
  requestFileUploadUrl: "REQUEST_FILE_UPLOAD_URL",
  fileUploadUrlSuccess: "FILE_UPLOAD_URL_SUCCESS",
  fileUploadUrlFailure: "FILE_UPLOAD_URL_FAILURE",
  requestFileUpload: "REQUEST_FILE_UPLOAD",
  fileUploadSuccess: "FILE_UPLOAD_SUCCESS",
  fileUploadFailure: "FILE_UPLOAD_FAILURE",
  buyplanBarcodeQtyImportRequest: "BUYPLAN_BARCODE_QTY_IMPORT_REQUEST",
  buyplanBarcodeQtyImportSuccess: "BUYPLAN_BARCODE_QTY_IMPORT_SUCCESS",
  buyplanBarcodeQtyImportFailure: "BUYPLAN_BARCODE_QTY_IMPORT_FAILURE"
};


export const requestFileUploadUrl = payload => {
  return {
    type: barcodeQtyImportActions.requestFileUploadUrl,
    payload
  };
};

export const fileUploadUrlSuccess = payload => {
  return {
    type: barcodeQtyImportActions.fileUploadUrlSuccess,
    payload
  };
};

export const fileUploadUrlFailure = errorPayload => {
  return {
    type: barcodeQtyImportActions.fileUploadUrlFailure,
    errorPayload
  };
};

export const requestFileUpload = payload => {
  return {
    type: barcodeQtyImportActions.requestFileUpload,
    payload
  };
};

export const fileUploadSuccess = payload => {
  return {
    type: barcodeQtyImportActions.fileUploadSuccess,
    payload
  };
};

export const fileUploadFailure = errorPayload => {
  return {
    type: barcodeQtyImportActions.fileUploadFailure,
    errorPayload
  };
};

export const buyplanBarcodeQtyImportRequest = payload => {
  return {
    type: barcodeQtyImportActions.buyplanBarcodeQtyImportRequest,
    payload
  };
};
